import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_INFO_APPLY_START, PUT_INFO_APPLY_ERROR, PUT_INFO_APPLY_START, PUT_INFO_APPLY_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/info-apply/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_INFO_APPLY_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_INFO_APPLY_ERROR, error });
  } finally {
    yield put({ type: GET_INFO_APPLY_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_info_apply() {
  yield takeLatest(PUT_INFO_APPLY_START, edit);
}


